export enum MenuItemType {
  CATEGORY,
  SUBCATEGORY,
  ITEM,
  MODIFIER,
  MODIFIER_GROUP,
}
